import { ClipboardCopy, Col, Grid, Row } from "@codat/orchard-ui";
import React from "react";
import Moment from "react-moment";
import { CompanySummary } from "../../../Models";
import IntegrationNugget from "../../IntegrationNugget/IntegrationNugget";
import LatestVersionChip from "../../LatestVersionChip/LatestVersionChip";
import styles from "../CompanyDetailsModal.module.css";
import className from "classnames";
import { startCase } from "lodash";

interface ConnectorTabProps {
  isLatest(integration: string, version: string): boolean;
  company: CompanySummary;
}

const ConnectorTab: React.FC<ConnectorTabProps> = ({ company, isLatest }) => {
  const isWebConnector = company.connectorIntegration === "qbwc";

  const latestVersionProps = {
    current: company.connectorVersion,
    integration: company.connectorIntegration,
    isLatest,
  };
  return (
    <Grid className={styles.grid}>
      <Row className={styles.row}>
        <Col size={3}>
          {isWebConnector ? "Data Connection ID" : "Connector ID"}
        </Col>
        <Col className={styles.connectorId}>
          <p>{company.connectorId}</p>
          <ClipboardCopy
            text={company.connectorId}
            className={styles.clipboard}
          />
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col>Connector Locale</Col>
        <Col className={styles.endCol} data-testid="connector-locale" size={3}>
          {company.connectorLocale ? (
            <p>{company.connectorLocale}</p>
          ) : (
            <p className={styles.unknown}>Unknown</p>
          )}
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col>Version Number</Col>
        <Col className={styles.integrationCol} size={isWebConnector ? 5 : 3}>
          <IntegrationNugget int={company.connectorIntegration} />
          <p>
            {isWebConnector
              ? "Web Connector (Version N/A)"
              : company.connectorVersion}
          </p>
          {isWebConnector || <LatestVersionChip value={latestVersionProps} />}
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col size={10} className={styles.lastConnectionCol}>
          <p>Last connection time</p>
          <p>Timezone • UTC</p>
        </Col>
        <Col size={4} className={styles.lastConnectionTime}>
          <Moment data-testid="last-seen" format="yyyy-MM-DD • HH:mm">
            {company.lastSeen}
          </Moment>
        </Col>
      </Row>

      <Row className={styles.row}>
        <Col size={10} className={styles.lastConnectionCol}>
          <p>Last action taken</p>
          <p>Time and function of the last action taken</p>
        </Col>
        <Col
          size={5}
          className={className(styles.lastConnectionCol, styles.endCol)}
        >
          {company.lastAction.dataType ? (
            <>
              <p data-test-id="last-action">
                {`${startCase(company.lastAction.dataType)} • ${
                  company.lastAction.action
                }`}
              </p>
              <p>
                <Moment format="yyyy-MM-DD • HH:mm">
                  {company.lastAction.date}
                </Moment>
              </p>
            </>
          ) : (
            <p className={styles.unknown} data-testid="last-action">
              Unknown
            </p>
          )}
        </Col>
      </Row>
    </Grid>
  );
};
export default ConnectorTab;
